import { slices } from "@/constants/sliceNames";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  analysisError: false,
};

const datasetAnalysisSlice = createSlice({
  name: slices.datasetAnalysis,
  initialState,
  reducers: {
    setAnalysisErrorState: (state, action) => {
      state.analysisError = action.payload.isError;
    },
  },
});

const { actions, reducer } = datasetAnalysisSlice;

export const { setAnalysisErrorState } = actions;

export default reducer;
